import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=1c4aac23&scoped=true&"
import script from "./DeviceSettings.vue?vue&type=script&lang=js&"
export * from "./DeviceSettings.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&id=1c4aac23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4aac23",
  null
  
)

export default component.exports